import { createContext } from 'react';
import { Client } from 'api';

export interface IClientContext {
  client: Client;
}

export default createContext<IClientContext>({
  client: null,
});
